import Isotope from "isotope-layout";

const filterPortfolio = (e) => {
  let portfolioContainer = document.querySelector(".portfolio-container");
  if (portfolioContainer) {
    let portfolioIsotope = new Isotope(portfolioContainer, {
      itemSelector: ".portfolio-item",
      filter: "filter-web",
    });
    let portfolioFilters = document.querySelectorAll("#portfolio-flters li");

    for (let i = 0; i < portfolioFilters.length; i++) {
      let el = portfolioFilters[i];
      el.classList && el.classList.remove("filter-active");
    }

    e.classList.add("filter-active");

    portfolioIsotope.arrange({
      filter: e.getAttribute("data-filter"),
    });
  }
};
export default filterPortfolio;
